import React, { useState, useEffect } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  Card,
  CardContent,
  CardHeader,
  FormControl,
  FormHelperText,
  Stack,
  ButtonGroup,
  LinearProgress,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialButton from "../../../../components/MaterialButton";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import axios from "axios";
import BASEURL from "../../../Utils/Baseurl";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import loading from "../../../../assest/images/loading.svg";
import error from "../../../../assest/images/404.svg";
import Swal from "sweetalert2";
import { useUserDetails } from "../../../../context/auth";
import "react-toastify/dist/ReactToastify.css";
import { useLoading } from "../../../../context/loading";
const AddDepartment = () => {
  const navigate = useNavigate();
  const { AccessData } = useUserDetails();
  const [id, setId] = useState(null);
  const [displaystate, setdisplaystate] = useState(false);
  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });
  const { circleLoading, setCirleLoading } = useLoading();
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  const [snackBar, setSnackBar] = useState({
    Success: false,
    Error: false,
  });
  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [departmentData, setDepartmentData] = useState({
    departmentName: "",
    departmentCode: "",
    departmentNameStatus: "unchecked",
    departmentCodeStatus: "unchecked",
  });


  const [originalDepartmentData, setOriginalDepartmentData] = useState({
    departmentName: "",
    departmentCode: "",
    departmentNameStatus: "unchecked",
    departmentCodeStatus: "unchecked",
  });

  useEffect(() => {
    console.log("sowmi",departmentData);
    
  })

  const [DepCode, setDepCode] = useState("");

  const generateJobId = () => {
    const prefix = "DEP"; // Prefix for Job ID
    const uniqueId = Date.now(); // Use timestamp as a unique identifier
    const randomSuffix = Math.floor(100 + Math.random() * 900); // 4-digit random number
    const newJobId = `${prefix}${randomSuffix}`;
    setDepCode(newJobId);
  };

  useEffect(() => {
    generateJobId();
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    setId(id);
    if (id) {
      getInitData(id);
    } else {
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    }
  }, []);

  const onDepartmentSubmit = async () => {
    setCirleLoading(true);
    const query = `mutation addDepartment($departmentName: String!) { 
  addDepartment(departmentName: $departmentName) { 
    departmentdetails { 
      id 
      departmentCode 
    } 
  } 
}`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            departmentName: departmentData.departmentName,
          },
        }),
      });
      console.log("response:", response);

      let Errordata = response.data.errors
  console.log('Errordata:',Errordata);
  
      setConfirmationDialog({ ...confirmationDialog, open: false });
      setSnackBar({
        ...snackBar,
        Success: true,
      });
      if (response.data.data.addDepartment?.departmentdetails != null) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Department Submitted successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/department");
      }else if(Errordata[0]?.message =='A department with this name already exists.'){
        Swal.fire({
          position: "center",
          icon: "error",
          title: Errordata[0]?.message,
          showConfirmButton: false,
          timer: 2500,
        });
        setConfirmationDialog({ ...confirmationDialog, open: false });
      }

      setCirleLoading(false);
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
      setConfirmationDialog({ ...confirmationDialog, open: false });
      setCirleLoading(false);
    }
  };

  const onEditDepartmentSubmit = async () => {
    setCirleLoading(true);
    const query = `mutation updateDepartment($id: ID!, $departmentName: String!, $departmentCode: String) { 
  DepartmentEdit(id: $id, departmentName: $departmentName, departmentCode: $departmentCode) { 
    departmentEditdetails { 
      id
      departmentName
      departmentCode
    }
  }
}`;

    try {
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query,
          variables: {
            id: id,
            departmentCode: departmentData.departmentCode,
            departmentName: departmentData.departmentName,
          },
        }),
      });

      console.log("responseUpdate:", response.data.errors);
      let result = response.data.data?.DepartmentEdit

  
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      setSnackBar({
        ...snackBar,
        Success: true,
      });

      let Errordata = response.data.errors
      console.log('Errordata:',Errordata);
    
      if(result !== null){
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Department Updated successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
         navigate("/department");
      }else if(Errordata[0]?.message =='A department with this name already exists.'){
        Swal.fire({
          position: "center",
          icon: "error",
          title: Errordata[0]?.message,
          showConfirmButton: false,
          timer: 2500,
        });
      }
    
      setCirleLoading(false);
     
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
      setCirleLoading(false);
    }
  };

  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteSubmitDepartment();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDeleteSubmitDepartment = async () => {
    setCirleLoading(true);
    const query = `
            mutation DeleteDepartment(
            $id:String!
          ) {
            deleteDepartment(id: $id) {
              success
              message
            }
          }
        `;

    try {
      const response = await axios.post(BASEURL, {
        query: query,
        variables: {
          id: id,
        },
      });

      if (response.data.data.deleteDepartment.success) {
        console.log("Department deleted successfully!");
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Department deleted successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/department");
      } else {
        console.log(
          "Error deleting Department:",
          response.data.data.deleteDepartment.message
        );
      }
      setCirleLoading(false);
    } catch (error) {
      console.error("An error occurred while deleting the Department:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
      setCirleLoading(false);
    }
  };

  const getInitData = async (id) => {
    setPageState({
      ...pageState,
      loading: true,
      state: "init",
    });
    const query = `query get_department($id: String!){
        getDepartmentById(id: $id){
        id
    		departmentName
    		departmentCode
                 }
             }`;
    try {
      setPageState({ ...pageState, loading: true });
      const response = await axios.post(
        BASEURL,
        {
          query: query,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      console.log("response:", response);
      const departmentRowdata = response.data.data.getDepartmentById;

      console.log("departmentRowdata", departmentRowdata);
      setDepartmentData({
        departmentName: departmentRowdata.departmentName,
        departmentCode: departmentRowdata.departmentCode,
        departmentNameStatus: departmentRowdata ? "success" : "unchecked",
      });

      setDepCode(departmentRowdata.departmentCode);

      setOriginalDepartmentData({
        departmentName: departmentRowdata.departmentName,
        departmentCode: departmentRowdata.departmentCode,
        departmentNameStatus: departmentRowdata ? "success" : "unchecked",
      });
      setTogglePage({
        ...togglePage,
        view: true,
      });
      setPageState((prevState) => ({
        ...prevState,
        loading: false,
        state: "default",
      }));
    } catch (error) {
      console.error("ResponseError:", error);

      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

  const handleDepartmentDatachange = (event) => {
    let departmentState = { ...departmentData };
    switch (event.target.name) {
      case "departmentCode": {
        const alphaNLengthRegex = new RegExp("^([a-zA-Z0-9]{1,10})$");

        if (alphaNLengthRegex.test(event.target.value?.trim())) {
          departmentState[event.target.name + "Status"] = "success";
        } else {
          departmentState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      case "departmentName": {
        const alphaNumberLengthRegex = new RegExp("^([A-Za-z ]{1,40})$");
        if (alphaNumberLengthRegex.test(event.target.value?.trim())) {
          departmentState[event.target.name + "Status"] = "success";
        } else {
          departmentState[event.target.name + "Status"] =
            event.target.value === "" ? "unchecked" : "error";
        }
        break;
      }
      default:
        break;
    }
    departmentState[event.target.name] = event.target.value;
    setDepartmentData(departmentState);
  };

  const onAddDepartment = () => {
  
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDepartmentSubmit();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  const AddDiscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Discards your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardDepartment();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDiscardDepartment = () => {
    setTogglePage({
      view: true,
      edit: false,
    });
    setDepartmentData({
      departmentName: originalDepartmentData.departmentName,
      departmentCode: originalDepartmentData.departmentCode,
    });
  };

  const checkAllFields = () => {
    let allowSubmit = false;
    if (departmentData.departmentNameStatus === "success") {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  const onCancelAction = () => {
    navigate("/department");
  };

  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      {pageState.state === "init" ? (
        <Card>
          <MaterialBox>
            <MaterialBox
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
                height: "40vh",
                margin: "auto",
              }}
            >
              <Grid
                container
                justifyContent="center"
                alignItems="center"
                spacing={2}
                padding={10}
              >
                <Grid size={{ xs: 6, sm: 6 }}>
                  <MaterialTypography variant="body2" mb={3}>
                    Please wait while we fetch the department details for you.
                    This may take a few seconds.
                  </MaterialTypography>
                  <MaterialBox
                    style={{
                      overflow: "hidden",
                      borderRadius: 5,
                      height: 24,
                    }}
                  >
                    <LinearProgress
                      size="lg"
                      color="dark"
                      thickness={16}
                      style={{
                        borderRadius: 5,
                        height: 16,
                        maxHeight: 16,
                      }}
                      sx={{
                        "& .MuiLinearProgress-bar": {
                          height: 16,
                        },
                      }}
                    />
                  </MaterialBox>
                </Grid>
              </Grid>
            </MaterialBox>
          </MaterialBox>
        </Card>
      ) : (
        <Card
          sx={{
            height: "80vh",
          }}
        >
          <CardHeader
            title={
              <>
                {AccessData &&
                  Array.isArray(AccessData) &&
                  AccessData.some(
                    (item) =>
                      item.component === "EditDepartment" && item.can_access
                  ) &&
                  (togglePage.view || togglePage.edit ? (
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                        {togglePage.view ? "View Department Details" : "Edit Department Details"}
                           
                        </MaterialTypography>
                      </Stack>

                      {pageState.state !== "submitting" && (
                        <ButtonGroup
                          variant="outlined"
                          aria-label="Loading button group"
                        >
                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}
                          >
                            Edit
                          </MaterialButton>
                          {/* Uncomment this block if you want to add delete functionality */}

                          <MaterialButton
                            variant="gradient"
                            color="dark"
                            onClick={AddDelete}
                            startIcon={<DeleteIcon />}
                          >
                            Delete
                          </MaterialButton>
                        </ButtonGroup>
                      )}
                    </Stack>
                  ) : (
                    <Stack
                      direction="row"
                      justifyContent="space-between"
                      alignItems="center"
                      spacing={2}
                    >
                      <Stack direction="column" spacing={0}>
                        <MaterialTypography variant="h5" fontWeight="medium">
                          Add Department Details
                        </MaterialTypography>
                      </Stack>
                    </Stack>
                  ))}
              </>
            }
          />
          <CardContent
            sx={{
              minHeight: pageState.state === "submitting" ? "50vh" : "50vh",
            }}
          >
            {pageState.state === "error" && (
              <MaterialBox>
                <Grid container spacing={1} textAlign="center">
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <img
                      src={error}
                      alt="error"
                      style={{
                        width: "30%",
                      }}
                    />
                  </Grid>
                  <Grid size={{ xs: 12, sm: 12 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography variant="h6" fontWeight="bold">
                        {pageState.message}
                      </MaterialTypography>
                    </MaterialBox>
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "default" && !pageState.loading && (
              <MaterialBox>
                <Grid container spacing={1}>
                  <Grid size={{ xs: 5, sm: 4 }}>
                    <MaterialBox lineHeight={0} display="inline-block">
                      <MaterialTypography
                        component="label"
                        variant="caption"
                        fontWeight="bold"
                      >
                        Department Name <span style={{ color: "red" }}>*</span>
                      </MaterialTypography>
                    </MaterialBox>
                    <MaterialInput
                      name="departmentName"
                      // placeholder="eg. IT"
                      value={departmentData.departmentName}
                      onChange={handleDepartmentDatachange}
                      error={departmentData.departmentNameStatus === "error"}
                      success={
                        departmentData.departmentNameStatus === "success"
                      }
                      disabled={togglePage.view === true ? true : false}
                    />
                    {departmentData.departmentNameStatus === "error" && (
                      <FormControl error>
                        <FormHelperText>
                          Department Name should be a maximum of 40 characters
                          long and can contain only alphabets.
                        </FormHelperText>
                      </FormControl>
                    )}
                  </Grid>
                </Grid>
              </MaterialBox>
            )}

            {pageState.state === "submitting" && !pageState.loading && (
              <MaterialBox>
                <MaterialBox
                  justifyContent="center"
                  alignItems="center"
                  display="flex"
                  flexDirection="column"
                  minHeight="50vh"
                >
                  <MaterialTypography
                    variant="h6"
                    fontWeight="bold"
                    textAlign="center"
                  >
                    Adding your deapartment data. This should not take much
                    time.
                  </MaterialTypography>
                  <MaterialBox mt={2}>
                    <img src={loading} alt="loading" width="200px" />
                  </MaterialBox>
                </MaterialBox>
              </MaterialBox>
            )}
          </CardContent>
          {pageState.state !== "submitting" && (
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
              {togglePage.edit === true ? (
                <>
                  <MaterialButton
                    variant="gradient"
                    color="dark"
                    disabled={pageState.state === "submitting"}
                    onClick={AddDiscard}
                  >
                    Discard
                  </MaterialButton>

                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={onEditDepartmentSubmit}
                  >
                    Update
                  </MaterialButton>
                </>
              ) : togglePage.view === false && togglePage.edit === false ? (
                <>
                  <MaterialButton
                    sx={{ m: 2 }}
                    variant="gradient"
                    color="dark"
                    onClick={handlecancel}
                  >
                    Cancel
                  </MaterialButton>
                  <MaterialButton
                  sx={{ m: 4, marginLeft: "4px" }}
                    variant="gradient"
                    color="dark"
                    disabled={
                      !checkAllFields() || pageState.state === "submitting"
                    }
                    onClick={onAddDepartment}
                  >
                    Submit
                  </MaterialButton>
                </>
              ) : null}
            </MaterialBox>
          )}
        </Card>
      )}
    </DashboardLayout>
  );
};

export default AddDepartment;
